import ResetDataButton from './ResetDataButton';
export default ResetDataButton;
